<template>
    <div v-if="show">
        <div class="modal">
            <div class="modal-dialog" :class="styleClass">
                <div class="modal-content-wrap">
                    <div class="head">
                        <button type="button" class="close" @click="close"><i class="icon-close"></i></button>
                        <h4 class="modal-title">{{ title }}</h4>
                    </div>

                    <div class="modal-content">
                        <Simplebar v-if="withScroll">
                            <div class="modal-body"><slot></slot></div>
                            <div class="modal-footer"><slot name="footer"></slot></div>
                        </Simplebar>
                        <div v-else>
                            <div class="modal-body"><slot></slot></div>
                            <div class="modal-footer"><slot name="footer"></slot></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop in"></div>
    </div>
</template>

<script type="text/babel">
import { mapActions } from 'vuex';
import Simplebar from 'simplebar-vue';
import { KEYS } from '../../constants';

export default {
    name: 'Modal',

    components: {
        Simplebar,
    },

    props: {
        title: {
            type: String,
            default: 'Modal',
        },
        show: {
            type: Boolean,
            default: false,
        },
        styleClass: {
            type: String,
            default: 'modal-full',
        },
        closeCallback: {
            type: Function,
            required: false,
            default: () => {},
        },
        withScroll: {
            type: Boolean,
            default: false,
        },
        escHandler: {
            type: Function,
            required: false,
            default() {
                this.close();
            },
        },
        enterHandler: {
            type: Function,
            required: false,
            default: () => {},
        },
    },

    data() {
        return {
            duration: null,
        };
    },

    watch: {
        show(value) {
            if (value) {
                document.body.classList.add('modal-open');
            } else {
                if (!this.duration) {
                    this.duration =
                        window.getComputedStyle(this.$el)['transition-duration'].replace('s', '') * 1000;
                }
                window.setTimeout(() => {
                    document.body.classList.remove('modal-open');
                }, this.duration || 0);
            }
        },
    },

    created() {
        this.addOnKeyDownHandler({
            handlerName: this.styleClass,
            handler: event => {
                event = event || window.event;
                if (this.show) {
                    switch (event.which) {
                        case KEYS.ESC:
                            this.escHandler();
                            return true;
                        case KEYS.ENTER:
                            this.enterHandler();
                            return true;
                    }
                }
            },
        });
    },

    beforeDestroy() {
        this.removeOnKeyDownHandler(this.styleClass);
    },

    methods: {
        ...mapActions({
            addOnKeyDownHandler: 'addOnKeyDownHandler',
            removeOnKeyDownHandler: 'removeOnKeyDownHandler',
        }),

        close() {
            this.closeCallback();
            this.$emit('close');
        },
    },
};
</script>
